type Env = 'PROD' | 'DEV' | 'LOCAL'
type EnvConfig = {
  [key in Env]: string
}

export const ENV: Env =
  import.meta.env.VITE_NODE_ENV === 'development'
    ? 'DEV'
    : import.meta.env.VITE_NODE_ENV === 'production'
    ? 'PROD'
    : 'LOCAL'

export const API: EnvConfig = {
  PROD: 'https://api-next-auto.nominasaps.com/api/v1/',
  DEV: 'https://api-auto-sbx.nominasaps.com/api/v1/',
  LOCAL: 'http://localhost:3000/api/v1/',
}

export const IA_MODE_API_URL: EnvConfig = {
  PROD: 'https://api-next-auto.nominasaps.com',
  DEV: 'https://api-auto-sbx.nominasaps.com',
  LOCAL: 'http://localhost:3000',
}

//TODO: Change this to the real IA_MODE endpoints per environment
export const IA_MODE_SCRIPT_URL: EnvConfig = {
  PROD: 'https://d2c722ogu1z0pb.cloudfront.net/embed/latest/ia-mode.js',
  DEV: 'https://d3mnhvwrfgu5yj.cloudfront.net/embed/latest/ia-mode.js',
  LOCAL: 'https://d3mnhvwrfgu5yj.cloudfront.net/embed/latest/ia-mode.js',
}

export const IA_MODE_AGENT_URL: EnvConfig = {
  PROD: 'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A438230549270%3Aruntime%2FagentServer_prod-kr4s4wEGWW/invocations?qualifier=DEFAULT',
  DEV: 'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A540244242786%3Aruntime%2FagentServer_dev-lLOS27Bblb/invocations?qualifier=DEFAULT',
  LOCAL:
    'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A540244242786%3Aruntime%2FagentServer_dev-lLOS27Bblb/invocations?qualifier=DEFAULT',
}
